<template>
  <div style="background-color: transparent;">
    <div class="">
        <div id="neonclock" class="neon-font" v-bind:class="[foreColor, borderRadius]">
            <span class="bartime">{{ hours }}:{{ minutes }}<span class="barampm">{{ ampm }}</span></span>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      hours: "",
      minutes: "",
      ampm: "",
      color: this.$route.query.color || 'sky',
      radius: this.$route.query.radius || 'round-border'
    };
  },

  computed: {
    foreColor: function() {
      if (this.color === 'sky') {
        return 'sky-neon';
      }
      else if (this.color === 'blue') {
        return 'blue-neon';
      }
      else if (this.color === 'red') {
        return 'red-neon';
      }
      else if (this.color === 'pink') {
        return 'pink-neon';
      }
      else if (this.color === 'lightgreen') {
        return 'lightgreen-neon';
      }
      else {
        return 'sky-neon';
      }
    },
    borderRadius: function() {
      return this.radius;
    }
  },
  mounted: function () {
    setInterval(this.updateTime, 1000);
  },
  methods: {
    updateTime: function () {
      let currentdate = new Date();
      let hours = currentdate.getHours();
      this.ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // 0時は12時として扱う
      this.hours = this.zeroPadding(hours, 2);
      this.minutes = this.zeroPadding(currentdate.getMinutes(), 2);
    },
    zeroPadding: function (num, len) {
      let zero = "";

      // 0の文字列を作成
      for (var i = 0; i < len; i++) {
        zero += "0";
      }

      // zeroの文字列と、数字を結合し、後ろ２文字を返す
      return (zero + num).slice(-len);
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');

p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

.content-title{
  text-align: center;
}

h2{
  position: relative;
  display: inline-block;
  padding: 0 65px;
  text-align: center;
  letter-spacing: 1px
}

h2:before,
h2:after {
  position: absolute;
  top: calc(50% - 3px);
  width: 50px;
  height: 6px;
  content: '';
  border-top: solid 2px #000;
  border-bottom: solid 2px #000;
}

h2:before {
  left: 0;
}

h2:after {
  right: 0;
}

h3{
  font-size: 14px;
  margin-top: 24px;
}

.main{
  max-width: 514px;
  margin: 0 auto;
}

#neonclock {
  width: 220px;
  height: 70px;
  padding: 14px 42px 0px 42px;
  margin: 12px;
  color: #fff;
  -webkit-align-self: flex-start;
  align-self: flex-start;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  background-color: transparent;
  border: 3px solid;
}

.round-border {
  border-radius: 100vh;
}

.square-border {
  border-radius: 10px;
}

.bartime {
  letter-spacing: 0.05em;
  font-size: 52px;
  line-height: 0.75em;
  margin-bottom: 10px;
}

.barampm {
  font-size: 0.7em;
  vertical-align: 2px;
  margin-left: 5px;
}

.sky-neon {
  color: #0ff;
  text-shadow: 0 0 5px #0ff, 0 0 10px #0ff, 0 0 5px #0ff, 0 0 10px #0ff;
  border-color: #0ff;
  box-shadow: 0 0 5px #0ff, 0 0 10px #0ff, inset 0 0 5px #0ff, inset 0 0 10px #0ff;
}

.blue-neon {
  color: #5271ff;
  text-shadow: 0 0 5px #5271ff, 0 0 10px #5271ff, 0 0 5px #5271ff, 0 0 10px #5271ff;
  border-color: #5271ff;
  box-shadow: 0 0 5px #5271ff, 0 0 10px #5271ff, inset 0 0 5px #5271ff, inset 0 0 10px #5271ff;
}

.red-neon {
  color: #f00;
  text-shadow: 0 0 5px #f00, 0 0 10px #f00, 0 0 20px #f00, 0 0 40px #f00;
  border-color: #f00;
  box-shadow: 0 0 5px #f00, 0 0 10px #f00, inset 0 0 5px #f00, inset 0 0 10px #f00;
}

.pink-neon {
  color: #ff00ff;
  text-shadow: 0 0 5px #ff00ff, 0 0 10px #ff00ff, 0 0 20px #ff00ff, 0 0 40px #ff00ff;
  border-color: #ff00ff;
  box-shadow: 0 0 5px #ff00ff, 0 0 10px #ff00ff, inset 0 0 5px #ff00ff, inset 0 0 10px #ff00ff;
}

.lightgreen-neon {
  color: #7fff00;
  text-shadow: 0 0 5px #7fff00, 0 0 10px #7fff00, 0 0 20px #7fff00, 0 0 40px #7fff00;
  border-color: #7fff00;
  box-shadow: 0 0 5px #7fff00, 0 0 10px #7fff00, inset 0 0 5px #7fff00, inset 0 0 10px #7fff00;
}

.neon-font{
  font-family: "Outfit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
}

.radio-main{
  display: -webkit-flex;
  display: flex;
  margin-top:12px;
}
.m-form-text{
  height: 2.4em;
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

</style>